import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #202529;
  width: 100vw;
  height: 100vh;
  position: relative;
`;

export const AnalizeLogo = styled.img`
  width: 162px;
  position: absolute;
  top: 45px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 28%;
  height: 34.8%;
  background-color: #32383d;
  border-radius: 10px;
  > div {
    margin-top: -25px;
  }
`;

export const RedirectTitle = styled.h3`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 8px;
`;

export const RedirectLabel = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
`;
